<template>
  <div id="content">
    <preview-popup
        :preview-data="previewData"
        :is-advertising-banner="true"
        :show-preview="preview"
        @hide-preview="hidePreview"
    />
    <broadcast-search
        v-model="entity.action_id"
        @broadcast-search-names="broadcastNames = arguments[0]"
        ref="broadcastsearchref"
        :multiple=false
    />
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a class="btn btn_action btn_grey btn_preview"
             :title="'Náhled' | translate"
             @click.stop="showPreview"
             v-translate>Náhled</a>
        </p>
        <h1 v-translate>Nové marketingové oznámení</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <Settings
              :isEditable="isEditable"
              :entity="entity"
              ref="settingsRef"
          />
          <Actions
              :isEditable="isEditable"
              :entity="entity"
              :broadcast-names="broadcastNames"
              @broadcast-search-modal="$refs.broadcastsearchref.showModal(true, arguments[0])"
              @broadcast-search-input="$refs.broadcastsearchref.selected = arguments[0]"
          />
          <DeviceGroupType
              :isEditable="isEditable"
              :entity="entity"
              @input="recalcRecipients"
          />
          <Message
              :isEditable="isEditable"
              :entity="entity"
              :is-update="isUpdate"
              ref="messageRef"
          />
          <Recipients
              :isEditable="isEditable"
              :entity="entity"
              :is-update="isUpdate"
              ref="recipientsRef"
          />
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
              <input
                  type="submit"
                  :value="'Uložit' | translate"
                  class="btn"
                  @click.prevent.stop="createNewAdvertisingBanner()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import entity from "./mixins/entity";
import detailActions from "../../mixins/detail-actions";
import Recipients from "./Forms/Recipients.vue";
import Settings from "./Forms/Settings.vue";
import DeviceGroupType from "./Forms/DeviceGroupType.vue";
import Message from "./Forms/Message.vue";
import Actions from "./Forms/Actions.vue";
import PreviewPopup from "../messages/popup/PreviewPopup.vue";
import BroadcastSearch from "../../common/BroadcastSearch.vue";

export default {
  name: "AdvertisingBannerNew",
  components: { PreviewPopup, Actions, Message, DeviceGroupType, Settings, Recipients, BroadcastSearch},
  mixins: [detailActions, entity],
  data(){
    return {
      moduleName: 'advertisingBanners',
      detailPageRouteName: 'advertisingBannerDetail',
      isEditable: true,
      isUpdate: false,
      preview: false,
      previewData: {},
      broadcastNames: {},
    }
  },
  created(AdvertisingBannerService) {
    this.entityService = AdvertisingBannerService;
  },
  methods:{
    recalcRecipients(){
      this.$refs['recipientsRef'].onRecipientsChange();
    },
    createNewAdvertisingBanner(){
      if(this.isRecipientsValid()) {
        this.createEntity();
      }else{
        this.setErrorMessage('Some recipients must be selected');
      }
    },
    showPreview: async function() {
      this.previewData = {
        ...(await this.$refs.settingsRef.getPreviewData()),
        ...this.$refs.messageRef.getPreviewData(),
      }
      this.preview = true
    },
    hidePreview() {
      this.preview = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/AdvertisingBannerNew.vue